import React, { useContext } from 'react'

import { ItemCardVariant } from '../types'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import ViewMoreOffersCta from 'tripPlanner/components/Buttons/ViewMoreOffersCta'
import { DetailItemCardVariant } from 'tripPlanner/components/DetailItemCard/common/types'
import LEOfferCTAs from 'tripPlanner/components/ItemCard/Common/LEOfferCTAs'
import { VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import { AccommodationItem } from 'tripPlanner/types/tripItem'
import { itemSectionId } from 'tripPlanner/utils/itemSection'
import { addTripIdParam } from 'tripPlanner/utils/url'

interface Props {
  item:
    | Utils.RequiredProp<AccommodationItem, 'savedItemData'>
  isOfferAvailable: boolean
  variant: ItemCardVariant | DetailItemCardVariant
  offerLink: string
}

export default function PlannedHotelCtaContent(props: Props) {
  const { isOfferAvailable, item, offerLink } = props
  const { startDate: checkIn, endDate: checkOut, code: offerId, tripId } = item
  const tripContext = useContext(TripContext)
  const viewAsTemplate = tripContext?.viewAsTemplate
  const isPublicTrip = tripContext?.isPublicTrip
  const canEdit = tripContext?.permissions.canEdit ?? false
  const buttonSize = props.variant == 'mapSummary' ? 'small' : 'medium'

  if (viewAsTemplate || isPublicTrip) {
    return (
      <Group
        direction={props.variant === 'mapSummary' ? 'vertical' : 'horizontal'}
        gap={12}
      >
        <SaveTripItemButton item={item} />
        <TextButton kind="primary" to={offerLink} target="_blank">
          {VIEW_OFFER_COPY}
        </TextButton>
      </Group>
    )
  } else if (!isOfferAvailable) {
    const hasPlannedInfo = !!checkIn || !!checkOut

    return (
      <Group
        direction="horizontal"
        gap={8}
        tabletHorizontalAlign="space-between"
        horizontalAlign="stretch"
      >
        {hasPlannedInfo && (
          <TextButton kind="tertiary" to={addTripIdParam(offerLink, tripId, canEdit)} target="_blank" size={buttonSize}>
            Change details
          </TextButton>
        )}
        <ViewMoreOffersCta
          offerId={offerId}
          checkIn={checkIn}
          checkOut={checkOut}
          sectionId={itemSectionId(item.id)}
          tripId={item.tripId}
          showSearch={props.variant === 'tripSummary'}
          size={buttonSize}
        />
      </Group>
    )
  } else {
    return <LEOfferCTAs item={item} variant={props.variant} />
  }
}
